<template lang="pug">
  #popup-waiting.popup__main
    .popup__header
      //- a(href="#" @click.prevent="closePopup").popup__close
    .popup__content
      .popup__title
        p(v-if="!videoUrl") 你的單曲下載#[br]檔案生成中#[br]請稍待片刻
        p(v-else) &nbsp;#[br]檔案生成完畢#[br]&nbsp;
      a.popup__button(href="#" @click.prevent="closePopup" v-if="!videoUrl") #[span OK]
      a.popup__button(href="#" @click.prevent="handleDownload" v-else) #[span 下載]
      //- a.popup__button(:href="videoUrl" target="_blank" v-else) #[span 下載]
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'PopupWaiting',
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(['popup', 'videoUrl', 'songData']),
  },
  methods: {
    ...mapActions(['closePopup']),
    handleDownload() {
      const { downloadVideo, videoUrl, closePopup } = this;
      if (navigator.share) {
        downloadVideo();
      } else {
        window.open(videoUrl, '_blank').focus();
      }
      closePopup();
    },
    downloadVideo() {
      const { videoUrl, songData } = this;
      fetch(videoUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const file = new File([blob], `${songData.MusicTitle}.mp4`, {type: 'video/mp4'});
          const filesArray = [file];
          if (navigator.canShare && navigator.canShare({ files: filesArray })) {
            navigator.share({
              files: filesArray,
              // title: songData.MusicTitle,
              // text: '',
              // url: ''
            });
          }
        });
    },
  },
  mounted() {
  },
  components: {
  }
}
</script>

<style lang="scss">

#popup-waiting {

  width: vw(348);
  height: vw(507);
  border: #fff vw(1) solid;
  box-shadow: rgba(#fff, 0.5) inset 0 0 vw(100), rgba(#ff47bc, 0.5) 0 0 vw(15), rgba(#ff47bc, 0.2) 0 0 vw(50);
  border-radius: vw(10);

  .popup__title {

    padding-top: vw(121);

    p {

      color: #fff;
      font-size: vw(30);
      font-weight: 400;
      line-height: lineHeight(30, 60);
      text-align: center;
      letter-spacing: vw(letterSpacing(500, 30));
      padding-left: vw(letterSpacing(500, 30));
      @include narrow-text;
      @include neon-text;

    }

  }

  .popup__button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: vw(154);
    height: vw(72);
    color: #fff;
    font-size: vw(30);
    font-weight: 500;
    letter-spacing: vw(letterSpacing(250, 30));
    padding-left: vw(letterSpacing(250, 30));
    margin: vw(64) auto 0;
    padding-bottom: vw(4);
    border-radius: vw(72);
    background: #d70d1a;
    span {
      display: inline-block;
      @include narrow-text;
    }
  }

}

</style>
